import ResultDetails from "../details/ResultDetails";

import { useSearchParams } from "react-router-dom";

export default function ResultHome() {
  const [searchParams] = useSearchParams();

  const jobId = searchParams.get("jobId");

  return jobId ? (
    <ResultDetails jobId={jobId} />
  ) : (
    <div>null</div>
  );
}